(($, duo) => {
  Drupal.behaviors.imagecarousel= {

    attach: function(context, settings) {
      if (context !== document) {
        return;
      }

      this.init(context, settings);
    },

    init: function(context, settings) {
      const self = this;

      // setup sliders:
      self.setupSliders();
    },

    setupSliders() {
      const self = this;

      let ticking = false;
      const hasNativeSmoothScroll = duo.Utils.testSupportsSmoothScroll;

      // process the slider navigation:
      const $sliderBlocks = $(document).find('.js-image-slider-holder');
      $sliderBlocks.each(function(index, element) {
        const $sliderBlock = $(element);
        const scrollableElement = $sliderBlock.find('.js-image-slider-list')[0];

        /* process slides */
        /* ************** */

        // count the number of slide items:
        const $slides = $sliderBlock.find('.js-image-slider-item');
        const nrOfSlides = $slides.length;

        // add an ID to every slide item:
        const starterId = 'p-slider-' + duo.Utils.uniqueId;
        $slides.each(function(i, e) {
          const $slide = $(e);
          $slide.attr('id', starterId + '-' + i);
        });

        /* slider navigation */
        /* ***************** */

        // create a navigation zone:
        let $navZone = $('<nav class="image-slider-nav"></nav>');

        // navigation arrows:
        let $sliderPrevBtn = $('<button>', {
          'class': 'image-slider-nav__btn image-slider-nav__btn--prev',
          'type': 'button',
           html: '<svg width="22" height="14" viewBox="0 0 22 14" aria-hidden="true" focusable="false"><path d="M7 13L1 7l6-6 1.3 1.3L4.5 6H21v2H4.5l3.7 3.7L7 13z"></path></svg>' +
                `<span class="visually-hidden">${Drupal.t('previous')}</span>`
        });
        let $sliderNextBtn = $('<button>', {
          'class': 'image-slider-nav__btn image-slider-nav__btn--next',
          'type': 'button',
           html: '<svg width="22" height="14" viewBox="0 0 22 14" aria-hidden="true" focusable="false"><path d="M13.8 11.7L17.5 8H1V6h16.5l-3.7-3.7L15 1l6 6-6 6-1.2-1.3z"></path></svg>' +
                `<span class="visually-hidden">${Drupal.t('next')}</span>`
        });
        let $sliderNav = $('<div>', {'class': 'image-slider-nav-arrows'}).append($sliderPrevBtn, $sliderNextBtn);
        $navZone.append($sliderNav);

        // arrow events:

        $sliderPrevBtn.on('click', function() {
          const button_is_disabled = $(this).attr('aria-disabled');
          if(button_is_disabled === undefined) {
            if(!$sliderPrevBtn.hasClass('js-busy')) {

              // -> scroll one screen:
              const scrollTarget = scrollableElement.scrollLeft - scrollableElement.clientWidth;
              duo.Utils.smoothScroll(scrollableElement, scrollTarget, true, hasNativeSmoothScroll);

              // -> prevent "fast clicks" on the button:
              $sliderPrevBtn.addClass('js-busy');
              setTimeout(function(){
                $sliderPrevBtn.removeClass('js-busy');
              }, 350);
            }
          }
        });

        $sliderNextBtn.on('click', function() {
          const button_is_disabled = $(this).attr('aria-disabled');
          if(button_is_disabled === undefined) {
            if(!$sliderNextBtn.hasClass('js-busy')) {

              // -> scroll one screen width:
              const scrollTarget = scrollableElement.scrollLeft + scrollableElement.clientWidth;
              duo.Utils.smoothScroll(scrollableElement, scrollTarget, true, hasNativeSmoothScroll);

              // -> prevent "fast clicks" on the button:
              $sliderNextBtn.addClass('js-busy');
              setTimeout(function(){
                $sliderNextBtn.removeClass('js-busy');
              }, 350);
            }
          }
        });

        // anchor links:
        let $navZoneList = $('<ol class="image-slider-nav-list"></ol>');
        for (let i = 0; i < nrOfSlides; i++) {
          const $navItem = $(`
            <li class="image-slider-nav-list__item">
              <a href="#${ starterId }-${ i }" class="image-slider-nav-list__link js-image-slider-bullet" data-index="${ i }">
                <span class="image-slider-nav-list__link-graphic"></span>
                <span class="visually-hidden">${ Drupal.t('Move to slide', {}, { context: 'custom' }) } ${ i + 1 }</span>
              </a>
            </li>
          `);
          $navZoneList.append($navItem);
        }
        $navZone.append($navZoneList);

        // add navzone to block:
        $sliderBlock.append($navZone);

        // set first anchor link as active:
        const $firstNavLink = $sliderBlock.find('.js-image-slider-bullet').first();
        if($firstNavLink.length > 0) {
          $firstNavLink.attr('aria-current', 'true');
        }

        // check navigation button states:
        self.checkButtonStates(scrollableElement);

        // navigation events:
        scrollableElement.addEventListener('scroll', (e) => {
          if (!ticking) {
            window.requestAnimationFrame(function() {

              // (1) update navigation buttons:
              self.checkButtonStates(scrollableElement);

              // (2) update navigation anchor links:

              // helper:
              let shouldUpdateNavLinks = false;

              // get the current scroll amount:
              const currentScoll = scrollableElement.scrollLeft;

              // slider-item width:
              const $scrollableElement = $(scrollableElement);
              const $firstSliderItem = $scrollableElement.find('.js-image-slider-item').first();
              const sliderItemWidth = $firstSliderItem.outerWidth();

              // divide the current scroll amount with the width of the slider,
              // and take the quotient - this will be the index of the current slide
              const scrollIndex = Math.ceil(currentScoll / sliderItemWidth);

              // get the currently active nav-link to check if we need to update the nav-links:
              const $currentActiveNavLink = $sliderBlock.find('.js-image-slider-bullet[aria-current]');
              if($currentActiveNavLink.length > 0) {
                const currentlyActiveNavLinkIndex = $currentActiveNavLink.attr('data-index');
                if(currentlyActiveNavLinkIndex != scrollIndex) {
                  shouldUpdateNavLinks = true;
                }
              }

              if(shouldUpdateNavLinks) {

                // get all navigation links and delete any "current" slide indications:
                const $allNavLinks = $sliderBlock.find('.js-image-slider-bullet');
                if($allNavLinks.length > 0) {
                  $allNavLinks.removeAttr('aria-current');
                }

                // set the current link as 'active':
                const $newLink = $sliderBlock.find(`.js-image-slider-bullet[data-index="${ scrollIndex }"]`);
                if($newLink.length > 0) {
                  $newLink.attr('aria-current', 'true');
                }
              }

              ticking = false;
            });
            ticking = true;
          }
        });
      });

      /* events */
      /* ****** */

      // slider navigation events:
      // -> navigation bullet click:
      $(document).on('click', '.js-image-slider-bullet', function(e) {

        // prevent the default anchor scroll:
        e.preventDefault();

        // get the parent-slider element:
        const $sliderLink = $(this);
        const $parentSlider = $sliderLink.parents('.js-image-slider-holder').find('.js-image-slider-list');
        const parentSlider = $parentSlider[0];

        // calculate where to scroll to:
        const slideIndex = $sliderLink.attr('data-index');
        const $firstSliderItem = $parentSlider.find('.js-image-slider-item').first();
        const sliderItemWidth = Math.floor($firstSliderItem.outerWidth());
        const positionToGoTo = slideIndex * sliderItemWidth;

        // smooth scroll to position:
        duo.Utils.smoothScroll(parentSlider, positionToGoTo, true, hasNativeSmoothScroll);
      });
    },

    checkButtonStates: function(sliderInstance) {
      const $parentBlock = $(sliderInstance).parents('.js-image-slider-holder');

      const clientWidth = sliderInstance.clientWidth;
      const sliderWidth = sliderInstance.scrollWidth;
      const maxScroll = sliderWidth - clientWidth;
      const currentScroll = sliderInstance.scrollLeft;
      const $sliderPrev = $parentBlock.find('.image-slider-nav__btn--prev');
      const $sliderNext = $parentBlock.find('.image-slider-nav__btn--next');

      // allow the scroll to be a few pixels off,
      // since the browser might not precisely scroll
      // to the "0" or "maxScroll" positions:
      const allowance = 5;

      if (currentScroll <= allowance) {
        $sliderPrev.attr('aria-disabled', 'true');
      } else {
        $sliderPrev.removeAttr('aria-disabled');
      }

      if (currentScroll >= maxScroll - allowance) {
        $sliderNext.attr('aria-disabled', 'true');
      } else {
        $sliderNext.removeAttr('aria-disabled');
      }
    }
  };
})(jQuery, window.duo = window.duo || {});
